import { useModal } from "../context/ModalContext";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  padding: 0 15px;
`;

const Button = styled.button`
  background-color: #22c55e;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #16a34a;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(34, 197, 94, 0.25);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(34, 197, 94, 0.2);
  }
`;

const Text = styled.span`
  font-size: 14px;
  color: #333;
`;

const Link = styled.a`
  font-size: 14px;
  color: #2563eb;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s ease;
  
  &:hover {
    color: #1d4ed8;
  }
`;

const CheckoutAuthBanner = ({ onSignInComplete }) => {
  const { setCurrentModal } = useModal();
  return (
    <Container>
      <Button type="button" onClick={() => setCurrentModal("signUp", onSignInComplete)}>
        Sign Up
      </Button>
      <Text>for faster checkout! or...</Text>
      <Link onClick={() => setCurrentModal("signIn", onSignInComplete)}>
        Log in
      </Link>
    </Container>
  );
}

export default CheckoutAuthBanner;
